export default "/assets/images/performance-filter-img-02.0e987a056c6c9b84.webp";